<template>
  <div class="language-selector d-flex">
    <Select
      v-model="locale"
      :size="size"
      :options="availableLocales"
      @update:model-value="saveLanguage"
    >
      <template #value="slotProps">
        <img
          :src="`/assets/flags/${slotProps.value}.svg`"
          alt="Country Icon"
          class="flag-image"
          width="20"
          height="20"
        />
      </template>
      <template #option="slotProps">
        <div class="flex align-items-center">
          <img
            :src="`/assets/flags/${slotProps.option}.svg`"
            alt="Country Icon"
            class="flag-image me-2"
          />
          <span>{{ slotProps.option.toLocaleUpperCase() }}</span>
        </div>
      </template>
    </Select>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n"
import { onBeforeMount } from "vue"
const { availableLocales, locale } = useI18n()

defineProps({
  size: {
    type: String,
    default: "",
    validator: (value) => ["small", "", "large"].includes(value)
  }
})

const saveLanguage = () => {
  localStorage.setItem("hotel-one-bi-locale", locale.value)
}

const preloadImage = (url) => {
  const img = new Image()
  img.src = url
}

onBeforeMount(() => {
  availableLocales.forEach((locale) => {
    preloadImage(`/assets/flags/${locale}.svg`)
  })
})
</script>
